import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { LandingPagePreviewMain } from 'src/components/landing-page'
import { useCoursePublish } from 'src/contexts/course-publish-context'

const useStyles = makeStyles({
  // Share › Links' draft warning, as wide as the landing page card.
  warning: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: '10px 14px',
    borderRadius: '8px',
    background: '#FFF4E5',
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#8A5A00',
  },
  warningIcon: {
    display: 'inline-flex',
    marginTop: 2,
  },
})

/** The course is in draft: its landing page links don't work for learners. */
const DraftNotice = () => {
  const classes = useStyles()
  const publishState = useCoursePublish()
  if (!publishState?.isLoaded || publishState.isPublished) return null
  return (
    <div className={classes.warning}>
      <span className={classes.warningIcon}>
        <Icon icon="tabler:alert-triangle" width={14} height={14} />
      </span>
      This course is in draft. Neither link works for learners until you publish
      it.
    </div>
  )
}

/** Preset picker, landing page URL / edit button and live preview. */
const LandingTab = () => <LandingPagePreviewMain notice={<DraftNotice />} />

export default LandingTab
